module.exports = __webpack_public_path__ + "static/media/crystallure_logo_big.8cc2969c.png";